// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3vHjg","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2bMQg"};